/*
 * @Description: 路由菜单
 * @Autor: kangpeng
 * @Date: 2020-04-17 11:45:58
 * @LastEditors: kangpeng
 * @LastEditTime: 2020-05-06 10:16:38
 */
const routes = [{
    path: '/',
    name: 'layout',
    redirect: 'home',
    component: () => import('@/layout'),
    meta: {
        title: '主页'
    },
    children: [{
            path: '/home',
            name: 'home',
            meta: {
                title: '首页'
            },
            component: () => import('@/pages/home'),
        },
        {
            path: '/venueRank',
            name: 'venueRank',
            meta: {
                title: '会场排行'
            },
            component: () => import('@/pages/venueRank')
        },
        {
            path: '/hotBusinessCircle',
            name: "hotBusinessCircle",
            meta: {
                title: '地图找会场'
            },
            component: () => import('@/pages/hotBusinessCircle')
        },
        {
            path: '/aboutUs',
            name: "aboutUs",
            meta: {
                title: '关于我们'
            },
            component: () => import('@/pages/aboutUs')
        },
        {
            path: '/venueCenter',
            name: "venueCenter",
            meta: {
                title: '会场中心'
            },
            component: () => import('@/pages/venueCenter'),
        },
        {
            path: '/venueDetails',
            name: 'venueDetails',
            meta: {
                title: '会场详情'
            },
            component: () => import('@/pages/venueDetails'),
        },
        {
            path: '/findVenueOnMap',
            name: 'findVenueOnMap',
            meta: {
                title: '地图找会场'
            },
            component: () => import('@/pages/findVenueOnMap')
        }

    ]
}]
export default routes